module.exports = __webpack_public_path__ + "index/img/qq.24c54944.svg";